import React from 'react';
import iconSizes from 'constants/iconSizes.js';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const CartPlusThick = ({ color = 'black', size = 'md', style: overrideStyles = {}, ...attr }) => {
  return (
    <svg style={{ ...style, ...overrideStyles }} viewBox="0 0 24 25" {...iconSizes[size]} fill="none" xmlns="http://www.w3.org/2000/svg" {...attr}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M12 4C10.6938 4 9.58254 4.83481 9.17071 6H14.8293C14.4175 4.83481 13.3062 4 12 4ZM12 2C9.58104 2 7.56329 3.71776 7.10002 6H4H3V7V20V21H4H20H21V20V7V6H20H16.9C16.4367 3.71776 14.419 2 12 2ZM5 8V19H19V8H5ZM11 10V12.5H8.5V14.5H11V17H13V14.5H15.5V12.5H13V10H11Z"
        fillRule="evenodd"
        clipRule="evenodd"
        fill={color}
      />
    </svg>
  );
};

export default CartPlusThick;
